/**
 * Public marketing site (punter home + venue page). Not the comedian apply hub.
 * @see docs/APP_UI_SPEC.md — G1, G2
 */

export const PUBLIC_NAV_LINKS = [
  { to: '/', label: 'Nights' },
  { to: '/for-venues', label: 'For venues' },
  { to: '/apply', label: 'Apply to perform' },
];

/** Dark bar on the marketing pages. Pale bar on the purple apply flow, including each night. */
const DARK_NAV_PATHS = new Set(['/', '/for-venues', '/legacy']);

export function publicNavVariantForPath(path) {
  if (DARK_NAV_PATHS.has(path) || String(path || '').startsWith('/admin')) return 'dark';
  return 'apply';
}

export function publicNavClassForPath(path) {
  return publicNavVariantForPath(path) === 'apply'
    ? 'public-nav public-nav--apply'
    : 'public-nav';
}

export const PUBLIC_VENUE_CONTACT = {
  name: 'Sam Joseph',
  email: 'sam@hilarityunlimited.com',
  phone: '07964 143662',
  telHref: 'tel:+447964143662',
  mailtoHref: 'mailto:sam@hilarityunlimited.com',
};

/** Muted home hero loop. */
export const PUBLIC_HERO_VIDEO = {
  src: '/videos/hero-audience.mp4',
  poster: '/videos/hero-audience.jpg',
};

/** Audience-facing nights. Keep apply URLs off these cards (G1). */
export const PUBLIC_NIGHTS = [
  {
    name: 'Sunset Comedy',
    area: 'Harrow',
    place: 'The Junction, Gayton Road',
    when: 'Fridays · 8:00pm',
    mapsUrl: 'https://maps.app.goo.gl/Q1NBtHp6DKZr9c4H9',
    eventbriteUrl: 'https://www.eventbrite.com/e/sunset-comedy-friday-fun-tickets-1988440677594',
  },
  {
    name: 'Craic-Up Comedy',
    area: 'Watford',
    place: "O'Neill's, Station Road",
    when: 'Mondays · 8:00pm',
    mapsUrl: 'https://maps.app.goo.gl/eRfGu2uDykZ87JuUA',
    eventbriteUrl: 'https://www.eventbrite.co.uk/e/craic-up-comedy-monday-mayhem-tickets-1994879907504',
  },
];
